import { useNavigate } from 'react-router-dom';

const Step1 = () => {
	const navigate = useNavigate();

	return (
		<main
			style={{
				minHeight: '100vh',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				padding: '24px',
				background:
					'radial-gradient(circle at top, rgba(5, 217, 232, 0.18), transparent 28%), linear-gradient(180deg, #07060d 0%, #12101d 100%)',
			}}
		>
			<button
				type="button"
				onClick={() => navigate('/step2')}
				style={{
					minWidth: 'min(100%, 420px)',
					minHeight: '120px',
					padding: '24px 36px',
					borderRadius: '24px',
					border: '1px solid rgba(255, 255, 255, 0.18)',
					background: 'linear-gradient(135deg, #05d9e8 0%, #39ff14 100%)',
					color: '#071018',
					fontSize: 'clamp(1.5rem, 4vw, 2.6rem)',
					fontWeight: 800,
					letterSpacing: '0.04em',
					cursor: 'pointer',
					boxShadow: '0 24px 60px rgba(5, 217, 232, 0.28)',
					textTransform: 'uppercase',
				}}
			>
				start
			</button>
		</main>
	);
};

export default Step1;

